import { Component } from '@angular/core';
import { CardStyleRendererStringTypeComponent } from './card-style-renderer-type-string.component';

@Component({
	selector: 'app-card-style-enum-renderer',
	templateUrl: './card-style-renderer-type-enum.component.html',
	styleUrls: ['./card-style-renderer-type-enum.component.scss']
})
export class CardStyleRendererEnumTypeComponent extends CardStyleRendererStringTypeComponent {

	constructor() {
		super();
	}

}
